import React, { useState } from 'react'
import { PersistentNotification } from '@reapitform/common-ui'
import { SectionTile } from '@reapitform/dashboard-ui'
import { useAgentBusinessDetails } from '../../../../api/agent-settings'
import BusinessDetailsDisplayView from './display-view'
import BusinessDetailsDisplayViewLoading from './display-view/loader'
import BusinessDetailsEditForm from './edit-form'

const BusinessDetailsSection: React.FC = () => {
  const [isEdited, setIsEdited] = useState(false)
  const { data, loading, queryKey, errorString, isRefetching } = useAgentBusinessDetails()

  const handleActionClick = () => {
    if (loading) return

    setIsEdited(true)
  }

  const handleActionClose = () => setIsEdited(false)

  const shouldShowLoading: boolean = isRefetching || loading

  return (
    <SectionTile
      title="Business Details"
      actionTitle={isEdited ? '' : 'Edit'}
      onActionClick={handleActionClick}
      disableMarginBottom
    >
      {shouldShowLoading && <BusinessDetailsDisplayViewLoading />}
      {!shouldShowLoading && isEdited && (
        <BusinessDetailsEditForm
          onClose={handleActionClose}
          onSuccess={handleActionClose}
          queryKey={queryKey}
          defaultData={data ?? undefined}
        />
      )}
      {!shouldShowLoading && !isEdited && <BusinessDetailsDisplayView data={data} />}
      {errorString && (
        <PersistentNotification isFullWidth isExpanded isInline intent="danger">
          Failed to load business details information, try refreshing your page.
        </PersistentNotification>
      )}
    </SectionTile>
  )
}

export default BusinessDetailsSection
